import { post,get} from '../libs/ajax.js'


/**
 * 获取处理列表
 * @returns 
 */
export function getTreatmentQueueApi(data) {
    return post('/treatment/queue', data)
}
/**
 * 跟新队列状态
 * @param {*} data 
 * @returns 
 */
export function updateTreatmentQueueApi(data) {
    return get('/treatment/get_status', data)
}
/**
 * 重试
 * @param {*} data 
 * @returns 
 */
export function getTreatmentRetryApi(data) {
    return get('/treatment/retry', data)
}
/**
 * 获取处理id
 * @param {*} data 
 * @returns 
 */
export function getTreatmentIdsApi(data) {
    return post('/treatment/get_search_list', data)
}